import { get } from "lodash-es";

import { firebaseErrors } from "./firebaseErrors";

export const parseErrorCode = (e: unknown) => {
  if (
    get(e, "message", "").includes("Only beta users are invited at this time.")
  ) {
    return "Only beta users are invited at this time.";
  }
  const code = get(e, "code", "").replace("auth/", "");
  return get(firebaseErrors, code, get(e, "message", get(e, "code", "")));
};
